import { defineComponent as _defineComponent } from 'vue'
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ChipStatus, BaseIcon } from '@warrenbrasil/nebraska-web';

import { IOrderItem } from '@/modules/wealth/services/portfolio-orders';

interface Props {
  orderItem: IOrderItem;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetailsContent',
  props: {
    orderItem: null
  },
  setup(__props: any) {



const statusMapper: { [key: string]: string } = {
  info: 'information',
  positive: 'positive',
  negative: 'negative',
  alert: 'alert'
};

return { __sfc: true,statusMapper, NebraskaColors, BaseText, ChipStatus, BaseIcon }
}

})